/**
 * Estado post-pago Mercado Pago: se guarda antes del redirect y se restaura
 * al volver a SoluQR (WhatsApp / copiar pedido).
 */

const KEY_PREFIX = 'soluqr_mp_order_return:';

export function mpReturnStorageKey(businessId) {
  return `${KEY_PREFIX}${String(businessId || '').trim()}`;
}

/**
 * @param {string} businessId
 * @param {object} payload
 */
export function saveMpOrderReturnSession(businessId, payload) {
  if (typeof sessionStorage === 'undefined') return;
  const bid = String(businessId || '').trim();
  if (!bid || !payload || typeof payload !== 'object') return;
  try {
    sessionStorage.setItem(
      mpReturnStorageKey(bid),
      JSON.stringify({
        ...payload,
        savedAt: new Date().toISOString(),
      }),
    );
  } catch {
    /* ignore quota */
  }
}

/**
 * @param {string} businessId
 * @returns {object | null}
 */
export function loadMpOrderReturnSession(businessId) {
  if (typeof sessionStorage === 'undefined') return null;
  const bid = String(businessId || '').trim();
  if (!bid) return null;
  try {
    const raw = sessionStorage.getItem(mpReturnStorageKey(bid));
    if (!raw) return null;
    const data = JSON.parse(raw);
    return data && typeof data === 'object' ? data : null;
  } catch {
    return null;
  }
}

/**
 * @param {string} businessId
 */
export function clearMpOrderReturnSession(businessId) {
  if (typeof sessionStorage === 'undefined') return;
  try {
    sessionStorage.removeItem(mpReturnStorageKey(String(businessId || '').trim()));
  } catch {
    /* ignore */
  }
}
